import Dexie, { type Table } from 'dexie';

import { type CartItem } from './schemas/cart.schema';

export interface IAppDB {
  items: Table<CartItem, string>;
}

export class AppDB extends Dexie implements IAppDB {
  public items!: Table<CartItem, string>;
  private schemas: Record<keyof IAppDB, string>;
  private static instance: AppDB | null = null;

  constructor(schemas: Record<keyof IAppDB, string>) {
    super('db');

    this.schemas = schemas;

    if (!schemas) {
      throw new Error(
        `Schemas não definidos. Passe um objeto com as chaves e valores indicando o nome da tabela e o índice primário. Logo após os índices primários, você pode definir os índices secundários. \nExemplo:\n\n{\nitems: "id, store_id, user_id",\nusers: "id, account_id"\n}`
      );
    }

    this.version(1).stores({
      ...this.schemas,
    });

    Object.keys(this.schemas).forEach(key => {
      this[key as keyof IAppDB] = this.table(key);
    });
  }

  // Método estático para obter instância única
  static getInstance(schemas: Record<keyof IAppDB, string>): AppDB {
    if (!AppDB.instance) {
      AppDB.instance = new AppDB(schemas);
    }
    return AppDB.instance;
  }
}
